export default {
  items: [
    {
      name: 'Dashboard',
      url: '',
      icon: 'icon-speedometer'
    },
  ]
}
